import { httpPost } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { WebSessionType, WebSession } from './types';

/**
 * Reports a web session to backend analytics API
 *
 * @method reportWebSession
 * @memberof Analytics
 * @param  {WebSessionType} type - Session type
 * @param  {string} uuid - Unique ID
 * @returns {Promise<WebSessionResponse>} - Success or failure
 */

export const reportWebSession = (type: WebSessionType, uuid: string): Promise<WebSession> => {
  return httpPost(`${Constants.BACKEND_URL}/analytics/web_session/${type}`, uuid)
    .then((response) => {
      if (response?.status === 200 && response?.data.success === true) {
        return {
          success: true,
        };
      } else {
        return {
          success: false,
        };
      }
    })
    .catch((error) => {
      throw Error(`Error sending websession data, ${error}`);
    });
};
